// Dependencies
import React from "react";

// Modules

// App
import { apiEndpoints } from "../../config";


import PostEdit from "../../partials/posts/postEdit";

export default function GalleryEdit() {
  return (
    <PostEdit
      apiEndpoint={apiEndpoints.gallery}
      screenClassName={"gallery"}
      categoryTitle={"Gallery category"}
      categoryName={"field_gallery_category"}
      targetVid={"gallery_categories"}
      returnRoute={"/galleries-creator"}
      backBtnText={"Galleries Library"}
      previewRoute={"/galleries/preview"}
      logCustomEventType={"Gallery"}
      //   extraFields={extraFields}
      featuredImageEnabled={true}
      editorProps={{
        title: true,
        subtitle: true,
        body: true,
        list: true,
        gallery: true,
      }}
    >
    </PostEdit>
  );
}
